import { httpRequest } from "@utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";
import { trasDsToTreeData } from "../dict/dictModel";
import { IMdOrgDetail, IMdOrgFields, IMdOrgSearch } from "./OrgTypes";



class OrgService {
  async insert(params: IMdOrgFields) {
    const apiUrl = "/org/insert";
    return await httpRequest.post<IMdOrgDetail>(apiUrl, params);
  }

  async disable(params: IMdOrgFields) {
    const apiUrl = "/org/disable";
    return await httpRequest.post<boolean>(apiUrl, params)
  }

  async find(params: IMdOrgFields) {
    const apiUrl = "/org/find";
    return await httpRequest.post<IMdOrgDetail[]>(apiUrl, params)
  }

  async orgDs(pcode: string) {
    let { retData } = await this.find({ pcode })
    return retData.map(el => ({
      label: el.name,
      value: el.code
    }));
  }

  async page(params: IMdOrgSearch) {
    const apiUrl = "/org/page";
    return await httpRequest.post<IPage<IMdOrgDetail>>(apiUrl, params)
  }

  async one(params: IMdOrgFields) {
    const apiUrl = "/org/one";
    return await httpRequest.post<IMdOrgDetail>(apiUrl, params)
  }

  /**
   * 全部树加载
   * @param params 
   * @returns 
   */
  async allTree(params: IMdOrgFields) {
    const apiUrl = "/org/allTree";
    params.branchList = ["main", "portal"];
    return await httpRequest.post<IMdOrgDetail[]>(apiUrl, params)
  }


  async oneTree(params: IMdOrgFields) {
    const apiUrl = "/org/oneTree";
    return await httpRequest.post<IMdOrgDetail>(apiUrl, params)
  }

  async sync(params: IMdOrgFields) {
    const apiUrl = "/org/sync";
    params.branchList = ["main", "portal"];
    return await httpRequest.post<boolean>(apiUrl, params, {
      timeout: 15000
    })
  }

  async syncPage(params: IMdOrgSearch) {
    const apiUrl = "/org/syncPage";
    params.branchList = ["main", "portal"];
    return await httpRequest.post<boolean>(apiUrl, params)
  }

  async syncOne(params: IMdOrgFields) {
    const apiUrl = "/org/syncOne";
    return await httpRequest.post<boolean>(apiUrl, params)
  }

  async orgTreeDs(params: IMdOrgFields) {
    let { retData } = await this.allTree(params);
    // retData.map(el=>({
    //     label:el.name,
    //     value:el.code,
    //     children:[]
    // }))
    let treeData = trasDsToTreeData(retData, "code", "name");
    return treeData;
  }
}

export const orgService = new OrgService();
